var _g, _g2, _g3, _rect, _rect2, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetireOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "351px",
    height: "324px",
    viewBox: "0 0 351 324",
    enableBackground: "new 0 0 351 324",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 91.447,
    y: 48.433,
    width: 250.98,
    height: 259.498
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#24BCFF",
    points: "203.688,48.425 89.69,162.422 89.69,323.612 203.688,437.584  364.876,437.584 478.874,323.612 478.874,162.422 364.876,48.425  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0.093,
    y: 63.031,
    width: 295.004,
    height: 245.837
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7DDD2",
    d: "M177.718,70.082c0,0-26.732-5.686-32.867,20.56c-0.877,12.248,3.944,17.935,3.944,17.935 s-8.4,6.327-11.507,15.247c-4.786,13.734,4.517,26.88,16.72,29.666c6.579,1.502,24.927-3.257,35.651-9.716 c0.924-0.556,13.003,6.007,30.566,5.484c19.094-0.571,30.938-19.412,22.795-38.623c-7.405-17.473-22.827-17.29-22.827-17.29 s4.203-15.853-12.214-25.492C193.081,59.104,180.129,63.741,177.718,70.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B785",
    d: "M172.214,171.863c-2.321,0.144-3.698,0.197-3.637,0.123c1.856-2.301,2.703-6.344,3.083-9.865 c0.279-2.59,0.308-4.895,0.298-6.016v-0.043c-0.003-0.356-0.009-0.586-0.014-0.656c-0.007-0.196,32.52-29.734,32.52-29.734 s5.707,35.74,11.844,42.301C216.673,168.37,183.425,171.163,172.214,171.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B785",
    d: "M204.464,128.811c-0.555,12.561-21.097,31.402-34.236,26.599c-9.91-3.622-13.107-13.59-18.365-42.459 c-0.346-1.899-0.546-3.691-0.619-5.381c-0.047-1.138-0.034-2.232,0.025-3.283c1.27-21.023,20.813-23.317,20.813-23.317 c10.078-0.872,19.985,0.924,26.463,10.16c7.497,10.691,6.348,28.071,5.922,37.683L204.464,128.811z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7DDD2",
    d: "M150.676,104.664c10.825-4.156,23.677-17.081,29.529-30.612c0,0-12.35-1.474-22.868,8.586 c-10.518,10.06-6.662,22.024-6.662,22.024L150.676,104.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7DDD2",
    d: "M190.701,105.175c-0.579-1.236-1.95-2.13-3.267-2.505c-3.629-1.034-9.67,0.353-11.025,1.371 c0,0-1.403,2.767,2.037,1.941c1.826-0.44,3.72-0.678,5.103-0.874C186.421,104.702,190.701,105.175,190.701,105.175z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7DDD2",
    d: "M150.788,109.758c0.261-1.339,1.375-2.538,2.557-3.222c3.268-1.882,9.466-2.004,11.03-1.345 c0,0,2.034,2.345-1.505,2.378c-1.878,0.016-3.773,0.244-5.161,0.39C154.824,108.262,150.788,109.758,150.788,109.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48462",
    d: "M169.76,116.654c-0.23,1.635-0.57,3.242-1.092,4.81c-0.539,1.618-1.462,3.057-2.063,4.633 c-0.707,1.86,1.705,3.255,3.048,4.134c0.45,0.294,0.868-0.425,0.421-0.718c-1.266-0.828-3.01-1.613-2.622-3.29 c0.199-0.861,1.059-2.04,1.404-2.886c0.85-2.081,1.394-4.239,1.706-6.463c0.074-0.523-0.729-0.75-0.803-0.222V116.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48462",
    d: "M165.722,99.782c3.668-0.469,7.315-0.648,11.005-0.8c0.802-0.033,0.806-1.28,0-1.247 c-3.689,0.15-7.337,0.329-11.005,0.8C164.935,98.637,164.926,99.883,165.722,99.782z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48462",
    d: "M175.943,94.979c-2.775,0.214-8.989,0.395-9.253,0.402c-0.802,0.026-0.807,1.254,0,1.247 c3.09-0.03,6.173-0.165,9.253-0.403C176.738,96.165,176.746,94.916,175.943,94.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7DDD2",
    d: "M209.329,106.412c-6.214,3.09-16.891-2.747-22.479-7.175c-3.317-2.628-14.248-15.753-12.045-21.071 c0,0,13.395-3.144,24.165,6.177C209.738,93.665,209.329,106.412,209.329,106.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EDE4",
    d: "M156.857,123.55c-4.454,0-8.163-2.412-8.596-5.818c-0.484-3.806,3.296-7.43,8.426-8.082 c2.437-0.31,4.825,0.085,6.726,1.11c1.99,1.075,3.22,2.71,3.461,4.607c0.484,3.805-3.296,7.43-8.427,8.082 C157.91,123.517,157.379,123.55,156.857,123.55z M158.306,111.209c-0.462,0-0.934,0.03-1.408,0.091 c-4.221,0.535-7.354,3.328-6.983,6.223c0.368,2.894,4.103,4.814,8.323,4.278c4.222-0.536,7.354-3.329,6.984-6.223 c-0.172-1.351-1.095-2.542-2.602-3.355C161.386,111.556,159.891,111.209,158.306,111.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EDE4",
    d: "M183.387,121.247c-1.987,0-3.871-0.382-5.444-1.119c-2.224-1.044-3.583-2.671-3.826-4.587 c-0.244-1.915,0.661-3.831,2.554-5.397c1.784-1.476,4.262-2.481,6.978-2.825c5.837-0.74,10.799,1.709,11.293,5.577 c0.492,3.868-3.693,7.481-9.532,8.222C184.729,121.205,184.052,121.247,183.387,121.247z M185.621,108.856 c-0.575,0-1.166,0.037-1.763,0.113c-2.404,0.305-4.58,1.178-6.125,2.455c-1.438,1.189-2.136,2.577-1.965,3.907 c0.17,1.33,1.193,2.499,2.883,3.291c1.815,0.852,4.142,1.153,6.545,0.846c4.749-0.604,8.454-3.517,8.092-6.363 c-0.318-2.488-3.658-4.251-7.667-4.251V108.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EDE4",
    d: "M174.306,114.075l-8.176,0.855l0.174,1.653l8.175-0.855L174.306,114.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EDE4",
    d: "M193.251,110.783c-0.412,0-0.794-0.264-0.914-0.67c-0.146-0.494,0.144-1.009,0.649-1.151l10.707-3.018 c0.504-0.145,1.033,0.142,1.18,0.633c0.146,0.493-0.146,1.009-0.651,1.151l-10.708,3.018c-0.089,0.026-0.178,0.037-0.265,0.037 H193.251z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004999",
    d: "M148.206,182.563c-5.553,2.401-13.324,6.096-17.951,9.975c-10.545,8.841-15.061,23.82-18.691,36.574 c-4.626,16.256-22.392,79.246-22.392,79.246l39.481-0.443c4.997-11.823,11.721-25.167,11.289-25.307 C145.536,245.141,147.69,183.695,148.206,182.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004999",
    d: "M264.794,191.059c-15.916-14.594-51.077-13.67-52.188-31.957c-25.538,2.216-27.833,1.843-42.009,3.14 c-1.373,9.962-13.141,16.556-22.392,20.318c-0.751,1.648-13.03,37.664-16.591,62.547c-1.851,12.931,8.107,36.336,8.077,36.278 c2.592,12.562,4.258,16.44,6.107,27.154l121.094,0.296C266.894,308.836,283.694,208.389,264.794,191.059z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.781,150.523c0,0-2.713,5.996-10.114,9.691c-2.985,1.177-5.781,1.699-8.006,1.906 c0.279-2.59,0.308-4.895,0.298-6.016v-0.043C178.028,156.037,184.95,154.076,189.781,150.523z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B785",
    d: "M194.471,260.328c0,0-22.074,1.41-33.409,9.707c-1.616,1.182-17.583,20.189-17.583,20.189 s0.689,4.258,11.805-3.805c0,0,3.45,3.63,9.771,6.52c2.542,1.162,6.451,0.727,8.996-0.285c-0.171-1.406-3.805-3.905-5.639-3.164 c-0.342,0.137,4.125-3.663,4.125-3.663s6.477,1.714,12.868-0.746c5.083-1.958,8.698-5.728,8.698-5.728 c0.064-9.863,0.37-19.025,0.37-19.025H194.471z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94415",
    d: "M165.352,293.396c0.151-0.062,0.272-0.194,0.312-0.366c0.061-0.277-0.115-0.55-0.394-0.611 c-0.77-0.168-1.214-0.503-1.357-1.021c-0.537-1.938,2.711-6.088,5.19-8.418c0.207-0.193,0.216-0.519,0.022-0.726 c-0.194-0.207-0.521-0.216-0.728-0.022c-2.221,2.089-6.224,6.744-5.476,9.439c0.172,0.623,0.683,1.434,2.13,1.75 C165.157,293.443,165.261,293.434,165.352,293.396L165.352,293.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94415",
    d: "M162.25,291.768c0.143-0.058,0.257-0.178,0.304-0.336c0.077-0.274-0.084-0.557-0.356-0.635 c-1.413-0.396-2.25-1.038-2.484-1.902c-0.701-2.584,3.606-7.043,5.92-9.439c0.524-0.543,0.977-1.01,1.305-1.383 c0.188-0.213,0.168-0.538-0.047-0.725c-0.212-0.188-0.538-0.168-0.725,0.047c-0.313,0.354-0.759,0.815-1.275,1.348 c-2.798,2.896-7.027,7.275-6.174,10.42c0.337,1.238,1.412,2.121,3.2,2.622c0.115,0.03,0.229,0.022,0.331-0.019L162.25,291.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94415",
    d: "M157.846,289.109c0.122-0.049,0.225-0.146,0.281-0.274c0.11-0.26-0.011-0.562-0.272-0.672 c-1.157-0.49-1.806-1.164-1.987-2.06c-0.632-3.138,4.485-8.364,7.233-11.175c0.524-0.534,0.977-0.997,1.329-1.38 c0.193-0.208,0.18-0.533-0.03-0.726c-0.209-0.192-0.533-0.179-0.727,0.03c-0.342,0.371-0.79,0.828-1.308,1.357 c-3.083,3.15-8.245,8.428-7.507,12.093c0.248,1.236,1.121,2.181,2.595,2.804C157.585,289.162,157.725,289.158,157.846,289.109 L157.846,289.109z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004999",
    d: "M252.58,268.27c0,0,9.06,16.932,11.658,40.269c0,0,40.964,6.761,28.499-43.595 c-5.662-22.877-14.718-63.726-27.203-73.518c-10.363-8.128-17.767-9.605-17.767-9.605s-15.545,7.943-10.548,29.186 C242.216,232.249,252.58,268.27,252.58,268.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B785",
    d: "M194.471,260.328l65.946,9.162c24.428,4.063,29.054,12.191,29.608,18.842 c1.388,16.604-18.876,22.166-34.791,18.102c-11.321-2.891-55.396-24.123-60.764-27.08 C188.258,277.098,191.129,260.361,194.471,260.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B2C24",
    d: "M178.254,113.651c0.647-0.589,1.379-1.071,2.134-1.415c0.759-0.339,1.547-0.552,2.341-0.587 c0.396-0.02,0.792-0.018,1.185,0.042c0.195,0.017,0.393,0.06,0.589,0.095c0.193,0.05,0.39,0.087,0.583,0.146 c0.772,0.221,1.53,0.55,2.283,0.929h0.006c0.35,0.177,0.762,0.022,0.925-0.346c0.147-0.336,0.034-0.733-0.255-0.933 c-0.783-0.537-1.666-0.945-2.601-1.187c-0.931-0.25-1.925-0.301-2.88-0.133c-0.955,0.164-1.86,0.559-2.633,1.119 c-0.389,0.277-0.742,0.597-1.061,0.948c-0.316,0.354-0.602,0.728-0.825,1.158c-0.035,0.066-0.011,0.151,0.052,0.188 c0.05,0.03,0.109,0.021,0.15-0.014l0.009-0.008L178.254,113.651z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B2C24",
    d: "M181.485,114.251c0.711,2.244,1.838,3.471,2.686,3.151c0.848-0.321,1.096-2.067,0.385-4.313 c-0.71-2.244-1.608-2.71-2.455-2.388c-0.848,0.321-1.325,1.306-0.617,3.55H181.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B2C24",
    d: "M157.746,116.582c0.697,2.25,1.818,3.482,2.668,3.165c0.85-0.316,1.106-2.062,0.408-4.312 c-0.696-2.25-1.593-2.717-2.441-2.401C157.531,113.35,157.048,114.333,157.746,116.582L157.746,116.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B2C24",
    d: "M163.288,115.594c-0.749-0.512-1.513-0.89-2.296-1.123c-0.783-0.235-1.581-0.323-2.356-0.253 c-0.776,0.07-1.544,0.303-2.267,0.672c-0.728,0.37-1.405,0.878-2.045,1.511l-0.005,0.004c-0.103,0.103-0.264,0.09-0.358-0.028 c-0.07-0.087-0.083-0.207-0.044-0.305c0.377-0.957,1.045-1.766,1.845-2.355c0.801-0.587,1.749-0.959,2.735-1.042 c0.984-0.085,1.983,0.117,2.876,0.56c0.89,0.441,1.688,1.125,2.228,2.001c0.072,0.118,0.048,0.277-0.057,0.356 c-0.076,0.057-0.174,0.055-0.248,0.006h-0.004L163.288,115.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M173.004,162.424c-0.465,3.469-1.179,6.916-2.108,10.289c-0.189,0.689,0.881,0.982,1.072,0.296 c0.956-3.473,1.669-7.016,2.148-10.585c0.095-0.704-1.017-0.698-1.11,0H173.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M179.296,161.871c-0.008,3.729-0.271,7.447-0.278,11.176c0,0.713,1.109,0.715,1.111,0 c0.007-3.729,0.27-7.447,0.276-11.176C180.406,161.158,179.298,161.157,179.296,161.871z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M186.698,161.318c0.398,3.782,0.62,7.579,1.019,11.362c0.074,0.701,1.185,0.709,1.111,0 c-0.398-3.783-0.62-7.58-1.019-11.362C187.735,160.616,186.624,160.609,186.698,161.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M194.306,161.101c0.746,3.77,1.199,7.59,1.943,11.36c0.139,0.7,1.209,0.402,1.071-0.296 c-0.743-3.771-1.196-7.59-1.942-11.36C195.239,160.107,194.169,160.402,194.306,161.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M208.001,159.989c0.995,3.321,2.243,6.561,3.237,9.882c0.204,0.682,1.277,0.393,1.072-0.295 c-0.996-3.322-2.243-6.563-3.239-9.883C208.869,159.011,207.795,159.301,208.001,159.989z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M165.046,173.139c6.994,0.75,14.023,0.909,21.049,0.6c6.925-0.305,13.887-0.848,20.749-1.848 c3.846-0.56,7.662-1.301,11.463-2.097c0.699-0.146,0.403-1.215-0.296-1.069c-6.483,1.359-12.984,2.435-19.583,3.036 c-7.296,0.665-14.622,1.146-21.95,1c-3.819-0.075-7.634-0.323-11.433-0.731C164.336,171.953,164.34,173.063,165.046,173.139 L165.046,173.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M200.783,160.54c0.959,3.634,1.892,7.276,2.926,10.89c0.195,0.686,1.268,0.394,1.071-0.296 c-1.034-3.612-1.969-7.256-2.926-10.889C201.673,159.556,200.602,159.848,200.783,160.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M245.385,267.186c5.579-4.481,12.967-6.494,20.023-6.856c6.921-0.356,13.904,1.038,19.826,4.733 c3.442,2.148,6.365,5.03,8.504,8.478c0.375,0.606,1.337,0.05,0.958-0.56c-8.096-13.051-25.186-16.205-39.136-12.119 c-3.962,1.162-7.735,2.951-10.961,5.541C244.043,266.85,244.833,267.629,245.385,267.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M245.375,266.298c2.524-5.907,6.766-10.954,12.185-14.423c0.6-0.384,0.042-1.343-0.561-0.957 c-5.569,3.564-9.986,8.743-12.582,14.822c-0.278,0.648,0.679,1.214,0.958,0.56V266.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M245.342,266.461c-1.832-10.243-2.68-20.628-3.722-30.972c-0.984-9.783-2.479-19.601-1.617-29.454 c0.484-5.538,1.769-11.012,4.242-16.014c0.313-0.637-0.644-1.201-0.959-0.56c-4.437,8.978-5.053,19.132-4.453,28.97 c0.308,5.035,0.955,10.038,1.474,15.055c0.542,5.256,1.023,10.519,1.584,15.771c0.625,5.854,1.343,11.7,2.379,17.497 c0.126,0.7,1.196,0.404,1.072-0.296V266.461z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1766C6",
    d: "M143.785,196.087c-2.876,10.204-5.752,20.408-8.396,30.675c-1.307,5.07-2.578,10.154-3.638,15.282 c-0.516,2.49-0.966,4.974-1.014,7.524c-0.057,3.14,0.351,6.275,0.992,9.344c1.692,8.082,4.877,15.786,7.614,23.55 c0.235,0.669,1.308,0.381,1.071-0.295c-2.429-6.89-5.165-13.707-6.974-20.794c-0.815-3.2-1.427-6.465-1.566-9.768 c-0.119-2.778,0.188-5.476,0.729-8.196c2.093-10.526,4.994-20.907,7.839-31.249c1.449-5.268,2.932-10.524,4.412-15.779 c0.194-0.688-0.878-0.98-1.071-0.296L143.785,196.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24934",
    d: "M181.517,134.884c-0.687,2.933-3.935,7.716-9.39,7.812c-4.295,0.076-6.277-2.98-7.396-6.137 c-0.059-0.166,2.172-1.95,6.329-0.622C173.816,134.28,181.52,134.877,181.517,134.884z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9B785",
    d: "M199.371,109.555c0,0,1.484-4.265,5.415-4.097s6.278,3.403,6.486,6.766 c0.17,2.751-0.968,10.672-8.976,14.263C201.555,126.819,199.371,109.555,199.371,109.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EDE4",
    d: "M165.246,136.909c1.659,0.21,3.966,0.511,5.649,0.417c3.767-0.209,9.854-1.903,9.834-1.88 c-0.782,0.958-5.9,4.374-10.043,3.967c-3.817-0.373-5.465-2.508-5.44-2.506V136.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48462",
    d: "M181.348,132.035c1.647,1.014,2.702,2.726,2.839,4.656c0.05,0.708,1.161,0.713,1.111,0 c-0.165-2.331-1.395-4.383-3.389-5.613C181.3,130.703,180.741,131.66,181.348,132.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48462",
    d: "M163.433,132.855c-1.153,1.668-1.601,3.626-1.313,5.628c0.102,0.706,1.189,0.489,1.09-0.216 c-0.246-1.716,0.154-3.362,1.14-4.786c0.407-0.59-0.509-1.216-0.916-0.628V132.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M207.856,125.727c0.233-1.431-0.739-2.779-2.174-3.012c-1.434-0.232-2.784,0.74-3.017,2.171 c-0.233,1.431,0.74,2.779,2.174,3.011S207.624,127.158,207.856,125.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38312F",
    d: "M132.711,308.831H39.213L0.378,220.309c-0.97-2.209,0.651-4.684,3.066-4.684h86.189 c1.329,0,2.534,0.787,3.067,2.002L132.711,308.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M65.738,264.036c0.407,2.178-0.304,4.129-2.219,4.511c-1.917,0.383-4.282-1.716-4.689-3.895 c-0.407-2.178,0.525-3.934,2.442-4.314c1.918-0.382,4.059,1.521,4.466,3.7V264.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423734",
    d: "M131.304,308.832l59.956,0.033v-5.928h-62.543L131.304,308.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423734",
    d: "M89.933,215.625c0,0,6.601,0.412,8.252,4.119c1.65,3.708,37.272,83.193,37.272,83.193h-6.74 L89.933,215.625z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -69.647,
    y: 35.433,
    width: 513.331,
    height: 288.748
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2479,
    clipPath: "url(#SVGID_6_)",
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -92.657,
    y: 249.529,
    width: 391.167,
    height: 41.854
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -69.647,
    y: 248.781,
    width: 370.094,
    height: 44.142
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-53.161,249.529 -56.495,249.529 -58.853,251.887 -58.853,255.221  -56.495,257.578 -53.161,257.578 -50.804,255.221 -50.804,251.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "14.448,249.529 11.114,249.529 8.757,251.887 8.757,255.221  11.114,257.578 14.448,257.578 16.805,255.221 16.805,251.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "59.521,249.529 56.187,249.529 53.83,251.887 53.83,255.221  56.187,257.578 59.521,257.578 61.878,255.221 61.878,251.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "149.667,249.529 146.332,249.529 143.975,251.887 143.975,255.221  146.332,257.578 149.667,257.578 152.024,255.221 152.024,251.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "206.008,249.529 202.674,249.529 200.317,251.887 200.317,255.221  202.674,257.578 206.008,257.578 208.365,255.221 208.365,251.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-64.429,260.797 -67.764,260.797 -70.121,263.154 -70.121,266.488  -67.764,268.846 -64.429,268.846 -62.073,266.488 -62.073,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-41.893,260.797 -45.227,260.797 -47.584,263.154 -47.584,266.488  -45.227,268.846 -41.893,268.846 -39.535,266.488 -39.535,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "14.448,260.797 11.114,260.797 8.757,263.154 8.757,266.488  11.114,268.846 14.448,268.846 16.805,266.488 16.805,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "25.716,260.797 22.383,260.797 20.025,263.154 20.025,266.488  22.383,268.846 25.716,268.846 28.073,266.488 28.073,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "59.521,260.797 56.187,260.797 53.83,263.154 53.83,266.488  56.187,268.846 59.521,268.846 61.878,266.488 61.878,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "149.667,260.797 146.332,260.797 143.975,263.154 143.975,266.488  146.332,268.846 149.667,268.846 152.024,266.488 152.024,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "239.813,260.797 236.479,260.797 234.121,263.154 234.121,266.488  236.479,268.846 239.813,268.846 242.17,266.488 242.17,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "284.885,260.797 281.551,260.797 279.194,263.154 279.194,266.488  281.551,268.846 284.885,268.846 287.242,266.488 287.242,263.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "14.448,272.065 11.114,272.065 8.757,274.423 8.757,277.756  11.114,280.113 14.448,280.113 16.805,277.756 16.805,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "59.521,272.065 56.187,272.065 53.83,274.423 53.83,277.756  56.187,280.113 59.521,280.113 61.878,277.756 61.878,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "82.057,272.065 78.723,272.065 76.366,274.423 76.366,277.756  78.723,280.113 82.057,280.113 84.415,277.756 84.415,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "104.594,272.065 101.26,272.065 98.903,274.423 98.903,277.756  101.26,280.113 104.594,280.113 106.951,277.756 106.951,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "217.276,272.065 213.942,272.065 211.584,274.423 211.584,277.756  213.942,280.113 217.276,280.113 219.633,277.756 219.633,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "228.544,272.065 225.209,272.065 222.853,274.423 222.853,277.756  225.209,280.113 228.544,280.113 230.902,277.756 230.902,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "284.885,272.065 281.551,272.065 279.194,274.423 279.194,277.756  281.551,280.113 284.885,280.113 287.242,277.756 287.242,274.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-86.966,283.334 -90.3,283.334 -92.657,285.69 -92.657,289.025  -90.3,291.383 -86.966,291.383 -84.609,289.025 -84.609,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-19.357,283.334 -22.691,283.334 -25.048,285.69 -25.048,289.025  -22.691,291.383 -19.357,291.383 -16.999,289.025 -16.999,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-8.089,283.334 -11.423,283.334 -13.78,285.69 -13.78,289.025  -11.423,291.383 -8.089,291.383 -5.731,289.025 -5.731,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "115.862,283.334 112.528,283.334 110.171,285.69 110.171,289.025  112.528,291.383 115.862,291.383 118.219,289.025 118.219,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "127.13,283.334 123.796,283.334 121.439,285.69 121.439,289.025  123.796,291.383 127.13,291.383 129.488,289.025 129.488,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "172.203,283.334 168.869,283.334 166.511,285.69 166.511,289.025  168.869,291.383 172.203,291.383 174.561,289.025 174.561,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "296.153,283.334 292.819,283.334 290.461,285.69 290.461,289.025  292.819,291.383 296.153,291.383 298.51,289.025 298.51,285.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-42.31,250.535 -44.81,250.535 -46.578,252.303 -46.578,254.803  -44.81,256.571 -42.31,256.571 -40.542,254.803 -40.542,252.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-8.505,250.535 -11.006,250.535 -12.774,252.303 -12.774,254.803  -11.006,256.571 -8.505,256.571 -6.737,254.803 -6.737,252.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "137.982,250.535 135.481,250.535 133.713,252.303 133.713,254.803  135.481,256.571 137.982,256.571 139.75,254.803 139.75,252.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "216.86,250.535 214.359,250.535 212.59,252.303 212.59,254.803  214.359,256.571 216.86,256.571 218.627,254.803 218.627,252.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "239.396,250.535 236.895,250.535 235.127,252.303 235.127,254.803  236.895,256.571 239.396,256.571 241.164,254.803 241.164,252.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "295.737,250.535 293.237,250.535 291.467,252.303 291.467,254.803  293.237,256.571 295.737,256.571 297.504,254.803 297.504,252.303  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "70.372,261.803 67.872,261.803 66.104,263.571 66.104,266.071  67.872,267.84 70.372,267.84 72.14,266.071 72.14,263.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "194.323,261.803 191.823,261.803 190.055,263.571 190.055,266.071  191.823,267.84 194.323,267.84 196.091,266.071 196.091,263.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-87.383,273.071 -89.883,273.071 -91.651,274.84 -91.651,277.34  -89.883,279.107 -87.383,279.107 -85.615,277.34 -85.615,274.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-31.042,273.071 -33.542,273.071 -35.31,274.84 -35.31,277.34  -33.542,279.107 -31.042,279.107 -29.274,277.34 -29.274,274.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-19.773,273.071 -22.274,273.071 -24.042,274.84 -24.042,277.34  -22.274,279.107 -19.773,279.107 -18.005,277.34 -18.005,274.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "36.568,273.071 34.067,273.071 32.299,274.84 32.299,277.34  34.067,279.107 36.568,279.107 38.336,277.34 38.336,274.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "126.713,273.071 124.213,273.071 122.445,274.84 122.445,277.34  124.213,279.107 126.713,279.107 128.481,277.34 128.481,274.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "137.982,273.071 135.481,273.071 133.713,274.84 133.713,277.34  135.481,279.107 137.982,279.107 139.75,277.34 139.75,274.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "36.568,284.34 34.067,284.34 32.299,286.107 32.299,288.607  34.067,290.376 36.568,290.376 38.336,288.607 38.336,286.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "104.177,284.34 101.677,284.34 99.908,286.107 99.908,288.607  101.677,290.376 104.177,290.376 105.945,288.607 105.945,286.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "137.982,284.34 135.481,284.34 133.713,286.107 133.713,288.607  135.481,290.376 137.982,290.376 139.75,288.607 139.75,286.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "160.518,284.34 158.017,284.34 156.25,286.107 156.25,288.607  158.017,290.376 160.518,290.376 162.286,288.607 162.286,286.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "228.127,284.34 225.627,284.34 223.86,286.107 223.86,288.607  225.627,290.376 228.127,290.376 229.895,288.607 229.895,286.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "250.664,284.34 248.163,284.34 246.395,286.107 246.395,288.607  248.163,290.376 250.664,290.376 252.432,288.607 252.432,286.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-88.216,252.547 -89.05,252.547 -89.639,253.137 -89.639,253.97  -89.05,254.559 -88.216,254.559 -87.627,253.97 -87.627,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-76.948,252.547 -77.781,252.547 -78.371,253.137 -78.371,253.97  -77.781,254.559 -76.948,254.559 -76.359,253.97 -76.359,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "1.929,252.547 1.096,252.547 0.507,253.137 0.507,253.97  1.096,254.559 1.929,254.559 2.519,253.97 2.519,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "24.466,252.547 23.633,252.547 23.043,253.137 23.043,253.97  23.633,254.559 24.466,254.559 25.055,253.97 25.055,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "47.003,252.547 46.169,252.547 45.579,253.137 45.579,253.97  46.169,254.559 47.003,254.559 47.592,253.97 47.592,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "80.807,252.547 79.973,252.547 79.385,253.137 79.385,253.97  79.973,254.559 80.807,254.559 81.396,253.97 81.396,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "125.88,252.547 125.047,252.547 124.457,253.137 124.457,253.97  125.047,254.559 125.88,254.559 126.469,253.97 126.469,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "159.685,252.547 158.851,252.547 158.261,253.137 158.261,253.97  158.851,254.559 159.685,254.559 160.274,253.97 160.274,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "170.953,252.547 170.119,252.547 169.53,253.137 169.53,253.97  170.119,254.559 170.953,254.559 171.542,253.97 171.542,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "193.49,252.547 192.656,252.547 192.067,253.137 192.067,253.97  192.656,254.559 193.49,254.559 194.078,253.97 194.078,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "227.293,252.547 226.461,252.547 225.871,253.137 225.871,253.97  226.461,254.559 227.293,254.559 227.883,253.97 227.883,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "249.83,252.547 248.996,252.547 248.408,253.137 248.408,253.97  248.996,254.559 249.83,254.559 250.42,253.97 250.42,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "272.367,252.547 271.533,252.547 270.944,253.137 270.944,253.97  271.533,254.559 272.367,254.559 272.955,253.97 272.955,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "283.635,252.547 282.801,252.547 282.211,253.137 282.211,253.97  282.801,254.559 283.635,254.559 284.225,253.97 284.225,253.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-88.216,263.815 -89.05,263.815 -89.639,264.404 -89.639,265.238  -89.05,265.828 -88.216,265.828 -87.627,265.238 -87.627,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-54.411,263.815 -55.245,263.815 -55.834,264.404 -55.834,265.238  -55.245,265.828 -54.411,265.828 -53.823,265.238 -53.823,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-31.875,263.815 -32.709,263.815 -33.298,264.404 -33.298,265.238  -32.709,265.828 -31.875,265.828 -31.286,265.238 -31.286,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-20.607,263.815 -21.441,263.815 -22.03,264.404 -22.03,265.238  -21.441,265.828 -20.607,265.828 -20.017,265.238 -20.017,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "1.929,263.815 1.096,263.815 0.507,264.404 0.507,265.238  1.096,265.828 1.929,265.828 2.519,265.238 2.519,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "35.734,263.815 34.901,263.815 34.311,264.404 34.311,265.238  34.901,265.828 35.734,265.828 36.323,265.238 36.323,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "47.003,263.815 46.169,263.815 45.579,264.404 45.579,265.238  46.169,265.828 47.003,265.828 47.592,265.238 47.592,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "80.807,263.815 79.973,263.815 79.385,264.404 79.385,265.238  79.973,265.828 80.807,265.828 81.396,265.238 81.396,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "92.075,263.815 91.242,263.815 90.653,264.404 90.653,265.238  91.242,265.828 92.075,265.828 92.665,265.238 92.665,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "103.344,263.815 102.51,263.815 101.921,264.404 101.921,265.238  102.51,265.828 103.344,265.828 103.933,265.238 103.933,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "114.612,263.815 113.778,263.815 113.189,264.404 113.189,265.238  113.778,265.828 114.612,265.828 115.201,265.238 115.201,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "137.148,263.815 136.315,263.815 135.725,264.404 135.725,265.238  136.315,265.828 137.148,265.828 137.738,265.238 137.738,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "159.685,263.815 158.851,263.815 158.261,264.404 158.261,265.238  158.851,265.828 159.685,265.828 160.274,265.238 160.274,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "182.221,263.815 181.387,263.815 180.798,264.404 180.798,265.238  181.387,265.828 182.221,265.828 182.811,265.238 182.811,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "204.758,263.815 203.924,263.815 203.335,264.404 203.335,265.238  203.924,265.828 204.758,265.828 205.347,265.238 205.347,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "227.293,263.815 226.461,263.815 225.871,264.404 225.871,265.238  226.461,265.828 227.293,265.828 227.883,265.238 227.883,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "261.099,263.815 260.265,263.815 259.676,264.404 259.676,265.238  260.265,265.828 261.099,265.828 261.688,265.238 261.688,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "272.367,263.815 271.533,263.815 270.944,264.404 270.944,265.238  271.533,265.828 272.367,265.828 272.955,265.238 272.955,264.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-76.948,275.084 -77.781,275.084 -78.371,275.673 -78.371,276.506  -77.781,277.096 -76.948,277.096 -76.359,276.506 -76.359,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-54.411,275.084 -55.245,275.084 -55.834,275.673 -55.834,276.506  -55.245,277.096 -54.411,277.096 -53.823,276.506 -53.823,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-43.143,275.084 -43.977,275.084 -44.566,275.673 -44.566,276.506  -43.977,277.096 -43.143,277.096 -42.554,276.506 -42.554,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "1.929,275.084 1.096,275.084 0.507,275.673 0.507,276.506  1.096,277.096 1.929,277.096 2.519,276.506 2.519,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "47.003,275.084 46.169,275.084 45.579,275.673 45.579,276.506  46.169,277.096 47.003,277.096 47.592,276.506 47.592,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "69.539,275.084 68.705,275.084 68.116,275.673 68.116,276.506  68.705,277.096 69.539,277.096 70.128,276.506 70.128,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "92.075,275.084 91.242,275.084 90.653,275.673 90.653,276.506  91.242,277.096 92.075,277.096 92.665,276.506 92.665,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "148.416,275.084 147.583,275.084 146.993,275.673 146.993,276.506  147.583,277.096 148.416,277.096 149.006,276.506 149.006,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "159.685,275.084 158.851,275.084 158.261,275.673 158.261,276.506  158.851,277.096 159.685,277.096 160.274,276.506 160.274,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "238.563,275.084 237.729,275.084 237.139,275.673 237.139,276.506  237.729,277.096 238.563,277.096 239.152,276.506 239.152,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "249.83,275.084 248.996,275.084 248.408,275.673 248.408,276.506  248.996,277.096 249.83,277.096 250.42,276.506 250.42,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "294.903,275.084 294.069,275.084 293.481,275.673 293.481,276.506  294.069,277.096 294.903,277.096 295.492,276.506 295.492,275.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-76.948,286.352 -77.781,286.352 -78.371,286.941 -78.371,287.774  -77.781,288.363 -76.948,288.363 -76.359,287.774 -76.359,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-43.143,286.352 -43.977,286.352 -44.566,286.941 -44.566,287.774  -43.977,288.363 -43.143,288.363 -42.554,287.774 -42.554,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "13.198,286.352 12.364,286.352 11.775,286.941 11.775,287.774  12.364,288.363 13.198,288.363 13.787,287.774 13.787,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "24.466,286.352 23.633,286.352 23.043,286.941 23.043,287.774  23.633,288.363 24.466,288.363 25.055,287.774 25.055,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "69.539,286.352 68.705,286.352 68.116,286.941 68.116,287.774  68.705,288.363 69.539,288.363 70.128,287.774 70.128,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "92.075,286.352 91.242,286.352 90.653,286.941 90.653,287.774  91.242,288.363 92.075,288.363 92.665,287.774 92.665,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "182.221,286.352 181.387,286.352 180.798,286.941 180.798,287.774  181.387,288.363 182.221,288.363 182.811,287.774 182.811,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "204.758,286.352 203.924,286.352 203.335,286.941 203.335,287.774  203.924,288.363 204.758,288.363 205.347,287.774 205.347,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "216.026,286.352 215.192,286.352 214.603,286.941 214.603,287.774  215.192,288.363 216.026,288.363 216.615,287.774 216.615,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "238.563,286.352 237.729,286.352 237.139,286.941 237.139,287.774  237.729,288.363 238.563,288.363 239.152,287.774 239.152,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "261.099,286.352 260.265,286.352 259.676,286.941 259.676,287.774  260.265,288.363 261.099,288.363 261.688,287.774 261.688,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "272.367,286.352 271.533,286.352 270.944,286.941 270.944,287.774  271.533,288.363 272.367,288.363 272.955,287.774 272.955,286.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-65.596,252.346 -66.596,252.346 -67.303,253.053 -67.303,254.053  -66.596,254.76 -65.596,254.76 -64.889,254.053 -64.889,253.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-31.792,252.346 -32.792,252.346 -33.499,253.053 -33.499,254.053  -32.792,254.76 -31.792,254.76 -31.085,254.053 -31.085,253.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "69.622,252.346 68.622,252.346 67.915,253.053 67.915,254.053  68.622,254.76 69.622,254.76 70.329,254.053 70.329,253.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "103.427,252.346 102.427,252.346 101.719,253.053 101.719,254.053  102.427,254.76 103.427,254.76 104.134,254.053 104.134,253.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "182.305,252.346 181.305,252.346 180.597,253.053 180.597,254.053  181.305,254.76 182.305,254.76 183.012,254.053 183.012,253.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "261.182,252.346 260.182,252.346 259.475,253.053 259.475,254.053  260.182,254.76 261.182,254.76 261.889,254.053 261.889,253.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "125.964,263.614 124.963,263.614 124.256,264.321 124.256,265.321  124.963,266.028 125.964,266.028 126.671,265.321 126.671,264.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "216.11,263.614 215.109,263.614 214.402,264.321 214.402,265.321  215.109,266.028 216.11,266.028 216.817,265.321 216.817,264.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-9.255,274.883 -10.255,274.883 -10.963,275.59 -10.963,276.59  -10.255,277.297 -9.255,277.297 -8.548,276.59 -8.548,275.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "171.036,274.883 170.036,274.883 169.329,275.59 169.329,276.59  170.036,277.297 171.036,277.297 171.743,276.59 171.743,275.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "182.305,274.883 181.305,274.883 180.597,275.59 180.597,276.59  181.305,277.297 182.305,277.297 183.012,276.59 183.012,275.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "204.841,274.883 203.84,274.883 203.133,275.59 203.133,276.59  203.84,277.297 204.841,277.297 205.548,276.59 205.548,275.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "261.182,274.883 260.182,274.883 259.475,275.59 259.475,276.59  260.182,277.297 261.182,277.297 261.889,276.59 261.889,275.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-54.328,286.15 -55.328,286.15 -56.035,286.857 -56.035,287.857  -55.328,288.564 -54.328,288.564 -53.621,287.857 -53.621,286.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "47.086,286.15 46.086,286.15 45.379,286.857 45.379,287.857  46.086,288.564 47.086,288.564 47.793,287.857 47.793,286.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "80.89,286.15 79.89,286.15 79.183,286.857 79.183,287.857  79.89,288.564 80.89,288.564 81.598,287.857 81.598,286.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-20.19,251.541 -21.857,251.541 -23.035,252.72 -23.035,254.387  -21.857,255.565 -20.19,255.565 -19.011,254.387 -19.011,252.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "36.151,251.541 34.484,251.541 33.305,252.72 33.305,254.387  34.484,255.565 36.151,255.565 37.33,254.387 37.33,252.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "92.492,251.541 90.825,251.541 89.647,252.72 89.647,254.387  90.825,255.565 92.492,255.565 93.671,254.387 93.671,252.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "115.028,251.541 113.362,251.541 112.183,252.72 112.183,254.387  113.362,255.565 115.028,255.565 116.207,254.387 116.207,252.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-76.531,262.809 -78.198,262.809 -79.377,263.988 -79.377,265.654  -78.198,266.834 -76.531,266.834 -75.352,265.654 -75.352,263.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-8.922,262.809 -10.589,262.809 -11.767,263.988 -11.767,265.654  -10.589,266.834 -8.922,266.834 -7.743,265.654 -7.743,263.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "171.369,262.809 169.702,262.809 168.524,263.988 168.524,265.654  169.702,266.834 171.369,266.834 172.549,265.654 172.549,263.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "250.247,262.809 248.58,262.809 247.402,263.988 247.402,265.654  248.58,266.834 250.247,266.834 251.426,265.654 251.426,263.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "295.321,262.809 293.653,262.809 292.475,263.988 292.475,265.654  293.653,266.834 295.321,266.834 296.498,265.654 296.498,263.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-65.263,274.078 -66.93,274.078 -68.109,275.256 -68.109,276.923  -66.93,278.102 -65.263,278.102 -64.084,276.923 -64.084,275.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "24.883,274.078 23.216,274.078 22.037,275.256 22.037,276.923  23.216,278.102 24.883,278.102 26.061,276.923 26.061,275.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "115.028,274.078 113.362,274.078 112.183,275.256 112.183,276.923  113.362,278.102 115.028,278.102 116.207,276.923 116.207,275.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "193.906,274.078 192.239,274.078 191.061,275.256 191.061,276.923  192.239,278.102 193.906,278.102 195.084,276.923 195.084,275.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "272.783,274.078 271.116,274.078 269.938,275.256 269.938,276.923  271.116,278.102 272.783,278.102 273.963,276.923 273.963,275.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-65.263,285.346 -66.93,285.346 -68.109,286.524 -68.109,288.191  -66.93,289.37 -65.263,289.37 -64.084,288.191 -64.084,286.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "-31.458,285.346 -33.125,285.346 -34.304,286.524 -34.304,288.191  -33.125,289.37 -31.458,289.37 -30.28,288.191 -30.28,286.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "2.346,285.346 0.679,285.346 -0.499,286.524 -0.499,288.191  0.679,289.37 2.346,289.37 3.525,288.191 3.525,286.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "58.687,285.346 57.02,285.346 55.842,286.524 55.842,288.191  57.02,289.37 58.687,289.37 59.866,288.191 59.866,286.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "148.866,285.379 147.199,285.379 146.021,286.558 146.021,288.225  147.199,289.403 148.866,289.403 150.045,288.225 150.045,286.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "193.906,285.346 192.239,285.346 191.061,286.524 191.061,288.191  192.239,289.37 193.906,289.37 195.084,288.191 195.084,286.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_10_)",
    fill: "#BFBFBF",
    points: "284.051,285.346 282.385,285.346 281.205,286.524 281.205,288.191  282.385,289.37 284.051,289.37 285.231,288.191 285.231,286.524  "
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -476.854,
    y: -1296,
    fill: "none",
    width: 1920,
    height: 1080
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -476.854,
    y: -1296,
    fill: "none",
    width: 1920,
    height: 1080
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -227.332,
    y: -9.749,
    width: 569.759,
    height: 320.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    clipPath: "url(#SVGID_12_)",
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 48.609,
    y: -9.749,
    width: 295.475,
    height: 159.017
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_14_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 46.189,
    y: -9.749,
    width: 296.238,
    height: 159.021
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "126.266,-9.749 123.65,-7.132 123.65,-3.431 126.266,-0.815  129.967,-0.815 132.584,-3.431 132.584,-7.132 129.967,-9.749  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "313.87,-9.749 311.254,-7.132 311.254,-3.431 313.87,-0.815  317.57,-0.815 320.187,-3.431 320.187,-7.132 317.57,-9.749  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "326.376,-9.749 323.76,-7.132 323.76,-3.431 326.376,-0.815  330.078,-0.815 332.695,-3.431 332.695,-7.132 330.078,-9.749  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "54.925,2.758 51.224,2.758 48.609,5.375 48.609,9.075  51.224,11.692 54.925,11.692 57.542,9.075 57.542,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "67.432,2.758 63.732,2.758 61.115,5.375 61.115,9.075  63.732,11.692 67.432,11.692 70.049,9.075 70.049,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "92.446,2.758 88.745,2.758 86.129,5.375 86.129,9.075  88.745,11.692 92.446,11.692 95.063,9.075 95.063,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "117.46,2.758 113.759,2.758 111.143,5.375 111.143,9.075  113.759,11.692 117.46,11.692 120.076,9.075 120.076,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.967,2.758 126.266,2.758 123.65,5.375 123.65,9.075  126.266,11.692 129.967,11.692 132.584,9.075 132.584,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "142.474,2.758 138.773,2.758 136.157,5.375 136.157,9.075  138.773,11.692 142.474,11.692 145.091,9.075 145.091,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "154.981,2.758 151.28,2.758 148.664,5.375 148.664,9.075  151.28,11.692 154.981,11.692 157.597,9.075 157.597,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "167.488,2.758 163.786,2.758 161.171,5.375 161.171,9.075  163.786,11.692 167.488,11.692 170.104,9.075 170.104,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,2.758 188.8,2.758 186.185,5.375 186.185,9.075  188.8,11.692 192.5,11.692 195.117,9.075 195.117,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "205.008,2.758 201.309,2.758 198.692,5.375 198.692,9.075  201.309,11.692 205.008,11.692 207.623,9.075 207.623,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "230.023,2.758 226.322,2.758 223.704,5.375 223.704,9.075  226.322,11.692 230.023,11.692 232.64,9.075 232.64,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "255.035,2.758 251.334,2.758 248.719,5.375 248.719,9.075  251.334,11.692 255.035,11.692 257.653,9.075 257.653,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "292.556,2.758 288.857,2.758 286.24,5.375 286.24,9.075  288.857,11.692 292.556,11.692 295.172,9.075 295.172,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "317.57,2.758 313.87,2.758 311.254,5.375 311.254,9.075  313.87,11.692 317.57,11.692 320.187,9.075 320.187,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "330.076,2.758 326.376,2.758 323.76,5.375 323.76,9.075  326.376,11.692 330.076,11.692 332.694,9.075 332.694,5.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "54.925,15.265 51.224,15.265 48.609,17.881 48.609,21.582  51.224,24.199 54.925,24.199 57.542,21.582 57.542,17.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "79.939,15.265 76.239,15.265 73.622,17.881 73.622,21.582  76.239,24.199 79.939,24.199 82.556,21.582 82.556,17.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "104.953,15.265 101.252,15.265 98.635,17.881 98.635,21.582  101.252,24.199 104.953,24.199 107.569,21.582 107.569,17.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.967,15.265 126.266,15.265 123.65,17.881 123.65,21.582  126.266,24.199 129.967,24.199 132.584,21.582 132.584,17.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "255.035,15.265 251.334,15.265 248.719,17.881 248.719,21.582  251.334,24.199 255.035,24.199 257.653,21.582 257.653,17.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "267.543,15.265 263.841,15.265 261.226,17.881 261.226,21.582  263.841,24.199 267.543,24.199 270.159,21.582 270.159,17.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "54.925,27.772 51.224,27.772 48.609,30.389 48.609,34.089  51.224,36.706 54.925,36.706 57.542,34.089 57.542,30.389  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "117.46,27.772 113.759,27.772 111.143,30.389 111.143,34.089  113.759,36.706 117.46,36.706 120.076,34.089 120.076,30.389  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "54.925,40.279 51.224,40.279 48.609,42.896 48.609,46.596  51.224,49.212 54.925,49.212 57.542,46.596 57.542,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "79.939,40.279 76.239,40.279 73.622,42.896 73.622,46.596  76.239,49.212 79.939,49.212 82.556,46.596 82.556,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "92.446,40.279 88.745,40.279 86.129,42.896 86.129,46.596  88.745,49.212 92.446,49.212 95.063,46.596 95.063,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "154.981,40.279 151.28,40.279 148.664,42.896 148.664,46.596  151.28,49.212 154.981,49.212 157.597,46.596 157.597,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "242.53,40.279 238.828,40.279 236.211,42.896 236.211,46.596  238.828,49.212 242.53,49.212 245.146,46.596 245.146,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "255.035,40.279 251.334,40.279 248.719,42.896 248.719,46.596  251.334,49.212 255.035,49.212 257.653,46.596 257.653,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "267.543,40.279 263.841,40.279 261.226,42.896 261.226,46.596  263.841,49.212 267.543,49.212 270.159,46.596 270.159,42.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.967,52.786 126.266,52.786 123.65,55.402 123.65,59.103  126.266,61.719 129.967,61.719 132.584,59.103 132.584,55.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "167.488,52.786 163.786,52.786 161.171,55.402 161.171,59.103  163.786,61.719 167.488,61.719 170.104,59.103 170.104,55.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "179.993,52.786 176.294,52.786 173.677,55.402 173.677,59.103  176.294,61.719 179.993,61.719 182.611,59.103 182.611,55.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,52.786 188.8,52.786 186.185,55.402 186.185,59.103  188.8,61.719 192.5,61.719 195.117,59.103 195.117,55.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "242.53,52.786 238.828,52.786 236.211,55.402 236.211,59.103  238.828,61.719 242.53,61.719 245.146,59.103 245.146,55.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "230.023,65.292 226.322,65.292 223.704,67.909 223.704,71.609  226.322,74.227 230.023,74.227 232.64,71.609 232.64,67.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "280.049,65.292 276.35,65.292 273.733,67.909 273.733,71.609  276.35,74.227 280.049,74.227 282.665,71.609 282.665,67.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "67.432,77.8 63.732,77.8 61.115,80.417 61.115,84.117  63.732,86.733 67.432,86.733 70.049,84.117 70.049,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "104.953,77.8 101.252,77.8 98.635,80.417 98.635,84.117  101.252,86.733 104.953,86.733 107.569,84.117 107.569,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "117.46,77.8 113.759,77.8 111.143,80.417 111.143,84.117  113.759,86.733 117.46,86.733 120.076,84.117 120.076,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "142.474,77.8 138.773,77.8 136.157,80.417 136.157,84.117  138.773,86.733 142.474,86.733 145.091,84.117 145.091,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,77.8 188.8,77.8 186.185,80.417 186.185,84.117  188.8,86.733 192.5,86.733 195.117,84.117 195.117,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "217.515,77.8 213.815,77.8 211.198,80.417 211.198,84.117  213.815,86.733 217.515,86.733 220.131,84.117 220.131,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "255.035,77.8 251.334,77.8 248.719,80.417 248.719,84.117  251.334,86.733 255.035,86.733 257.653,84.117 257.653,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "317.57,77.8 313.87,77.8 311.254,80.417 311.254,84.117  313.87,86.733 317.57,86.733 320.187,84.117 320.187,80.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "167.488,90.307 163.786,90.307 161.171,92.923 161.171,96.624  163.786,99.24 167.488,99.24 170.104,96.624 170.104,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,90.307 188.8,90.307 186.185,92.923 186.185,96.624  188.8,99.24 192.5,99.24 195.117,96.624 195.117,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "205.008,90.307 201.309,90.307 198.692,92.923 198.692,96.624  201.309,99.24 205.008,99.24 207.623,96.624 207.623,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "230.023,90.307 226.322,90.307 223.704,92.923 223.704,96.624  226.322,99.24 230.023,99.24 232.64,96.624 232.64,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "242.53,90.307 238.828,90.307 236.211,92.923 236.211,96.624  238.828,99.24 242.53,99.24 245.146,96.624 245.146,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "292.556,90.307 288.857,90.307 286.24,92.923 286.24,96.624  288.857,99.24 292.556,99.24 295.172,96.624 295.172,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "305.064,90.307 301.364,90.307 298.746,92.923 298.746,96.624  301.364,99.24 305.064,99.24 307.681,96.624 307.681,92.923  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "154.981,102.813 151.28,102.813 148.664,105.43 148.664,109.13  151.28,111.747 154.981,111.747 157.597,109.13 157.597,105.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "217.515,102.813 213.815,102.813 211.198,105.43 211.198,109.13  213.815,111.747 217.515,111.747 220.131,109.13 220.131,105.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "267.543,102.813 263.841,102.813 261.226,105.43 261.226,109.13  263.841,111.747 267.543,111.747 270.159,109.13 270.159,105.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "292.556,102.813 288.857,102.813 286.24,105.43 286.24,109.13  288.857,111.747 292.556,111.747 295.172,109.13 295.172,105.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,115.32 188.8,115.32 186.185,117.937 186.185,121.636  188.8,124.254 192.5,124.254 195.117,121.636 195.117,117.937  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "317.57,115.32 313.87,115.32 311.254,117.937 311.254,121.636  313.87,124.254 317.57,124.254 320.187,121.636 320.187,117.937  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "330.076,115.32 326.376,115.32 323.76,117.937 323.76,121.636  326.376,124.254 330.076,124.254 332.694,121.636 332.694,117.937  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "67.432,127.828 63.732,127.828 61.115,130.444 61.115,134.145  63.732,136.761 67.432,136.761 70.049,134.145 70.049,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "154.981,127.828 151.28,127.828 148.664,130.444 148.664,134.145  151.28,136.761 154.981,136.761 157.597,134.145 157.597,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,127.828 188.8,127.828 186.185,130.444 186.185,134.145  188.8,136.761 192.5,136.761 195.117,134.145 195.117,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "217.515,127.828 213.815,127.828 211.198,130.444 211.198,134.145  213.815,136.761 217.515,136.761 220.131,134.145 220.131,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "242.53,127.828 238.828,127.828 236.211,130.444 236.211,134.145  238.828,136.761 242.53,136.761 245.146,134.145 245.146,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "292.556,127.828 288.857,127.828 286.24,130.444 286.24,134.145  288.857,136.761 292.556,136.761 295.172,134.145 295.172,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "305.064,127.828 301.364,127.828 298.746,130.444 298.746,134.145  301.364,136.761 305.064,136.761 307.681,134.145 307.681,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "317.57,127.828 313.87,127.828 311.254,130.444 311.254,134.145  313.87,136.761 317.57,136.761 320.187,134.145 320.187,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "330.076,127.828 326.376,127.828 323.76,130.444 323.76,134.145  326.376,136.761 330.076,136.761 332.694,134.145 332.694,130.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "104.953,140.334 101.252,140.334 98.635,142.951 98.635,146.651  101.252,149.268 104.953,149.268 107.569,146.651 107.569,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "154.981,140.334 151.28,140.334 148.664,142.951 148.664,146.651  151.28,149.268 154.981,149.268 157.597,146.651 157.597,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "167.488,140.334 163.786,140.334 161.171,142.951 161.171,146.651  163.786,149.268 167.488,149.268 170.104,146.651 170.104,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.5,140.334 188.8,140.334 186.185,142.951 186.185,146.651  188.8,149.268 192.5,149.268 195.117,146.651 195.117,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "217.515,140.334 213.815,140.334 211.198,142.951 211.198,146.651  213.815,149.268 217.515,149.268 220.131,146.651 220.131,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "242.53,140.334 238.828,140.334 236.211,142.951 236.211,146.651  238.828,149.268 242.53,149.268 245.146,146.651 245.146,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "255.035,140.334 251.334,140.334 248.719,142.951 248.719,146.651  251.334,149.268 255.035,149.268 257.653,146.651 257.653,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "280.049,140.334 276.35,140.334 273.733,142.951 273.733,146.651  276.35,149.268 280.049,149.268 282.665,146.651 282.665,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "305.064,140.334 301.364,140.334 298.746,142.951 298.746,146.651  301.364,149.268 305.064,149.268 307.681,146.651 307.681,142.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "51.687,-8.632 49.725,-6.67 49.725,-3.895 51.687,-1.932  54.462,-1.932 56.425,-3.895 56.425,-6.67 54.462,-8.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "89.208,-8.632 87.245,-6.67 87.245,-3.895 89.208,-1.932  91.983,-1.932 93.946,-3.895 93.946,-6.67 91.983,-8.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "164.249,-8.632 162.287,-6.67 162.287,-3.895 164.249,-1.932  167.025,-1.932 168.987,-3.895 168.987,-6.67 167.025,-8.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "201.77,-8.632 199.807,-6.67 199.807,-3.895 201.77,-1.932  204.546,-1.932 206.508,-3.895 206.508,-6.67 204.546,-8.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "226.783,-8.632 224.821,-6.67 224.821,-3.895 226.783,-1.932  229.56,-1.932 231.521,-3.895 231.521,-6.67 229.56,-8.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "251.798,-8.632 249.836,-6.67 249.836,-3.895 251.798,-1.932  254.573,-1.932 256.535,-3.895 256.535,-6.67 254.573,-8.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.997,16.381 114.222,16.381 112.26,18.344 112.26,21.119  114.222,23.081 116.997,23.081 118.96,21.119 118.96,18.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "167.025,16.381 164.249,16.381 162.287,18.344 162.287,21.119  164.249,23.081 167.025,23.081 168.987,21.119 168.987,18.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.039,16.381 189.263,16.381 187.3,18.344 187.3,21.119  189.263,23.081 192.039,23.081 194.002,21.119 194.002,18.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "242.066,16.381 239.292,16.381 237.329,18.344 237.329,21.119  239.292,23.081 242.066,23.081 244.029,21.119 244.029,18.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "317.108,16.381 314.333,16.381 312.37,18.344 312.37,21.119  314.333,23.081 317.108,23.081 319.071,21.119 319.071,18.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "79.477,28.889 76.701,28.889 74.739,30.851 74.739,33.626  76.701,35.589 79.477,35.589 81.439,33.626 81.439,30.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "204.546,28.889 201.77,28.889 199.807,30.851 199.807,33.626  201.77,35.589 204.546,35.589 206.508,33.626 206.508,30.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "292.094,28.889 289.318,28.889 287.355,30.851 287.355,33.626  289.318,35.589 292.094,35.589 294.057,33.626 294.057,30.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "339.347,28.889 337.384,30.851 337.384,33.625 339.347,35.589  342.121,35.589 344.083,33.625 344.083,30.851 342.121,28.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "329.615,41.396 326.839,41.396 324.878,43.358 324.878,46.133  326.839,48.096 329.615,48.096 331.577,46.133 331.577,43.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "267.08,53.902 264.305,53.902 262.342,55.864 262.342,58.64  264.305,60.602 267.08,60.602 269.043,58.64 269.043,55.864  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "79.477,66.41 76.701,66.41 74.739,68.371 74.739,71.146  76.701,73.109 79.477,73.109 81.439,71.146 81.439,68.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "142.01,66.41 139.236,66.41 137.274,68.371 137.274,71.146  139.236,73.109 142.01,73.109 143.973,71.146 143.973,68.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "217.052,66.41 214.277,66.41 212.315,68.371 212.315,71.146  214.277,73.109 217.052,73.109 219.015,71.146 219.015,68.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "317.108,66.41 314.333,66.41 312.37,68.371 312.37,71.146  314.333,73.109 317.108,73.109 319.071,71.146 319.071,68.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.983,91.423 89.208,91.423 87.245,93.385 87.245,96.161  89.208,98.123 91.983,98.123 93.946,96.161 93.946,93.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "142.01,91.423 139.236,91.423 137.274,93.385 137.274,96.161  139.236,98.123 142.01,98.123 143.973,96.161 143.973,93.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "254.573,91.423 251.798,91.423 249.836,93.385 249.836,96.161  251.798,98.123 254.573,98.123 256.535,96.161 256.535,93.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "279.586,91.423 276.812,91.423 274.849,93.385 274.849,96.161  276.812,98.123 279.586,98.123 281.549,96.161 281.549,93.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "339.347,91.423 337.384,93.385 337.384,96.161 339.347,98.123  342.121,98.123 344.083,96.161 344.083,93.385 342.121,91.423  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "179.532,103.93 176.756,103.93 174.794,105.892 174.794,108.667  176.756,110.63 179.532,110.63 181.494,108.667 181.494,105.892  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "192.039,103.93 189.263,103.93 187.3,105.892 187.3,108.667  189.263,110.63 192.039,110.63 194.002,108.667 194.002,105.892  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "254.573,103.93 251.798,103.93 249.836,105.892 249.836,108.667  251.798,110.63 254.573,110.63 256.535,108.667 256.535,105.892  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "304.602,103.93 301.824,103.93 299.862,105.892 299.862,108.667  301.824,110.63 304.602,110.63 306.565,108.667 306.565,105.892  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "79.477,116.438 76.701,116.438 74.739,118.4 74.739,121.174  76.701,123.137 79.477,123.137 81.439,121.174 81.439,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.997,116.438 114.222,116.438 112.26,118.4 112.26,121.174  114.222,123.137 116.997,123.137 118.96,121.174 118.96,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "142.01,116.438 139.236,116.438 137.274,118.4 137.274,121.174  139.236,123.137 142.01,123.137 143.973,121.174 143.973,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "167.025,116.438 164.249,116.438 162.287,118.4 162.287,121.174  164.249,123.137 167.025,123.137 168.987,121.174 168.987,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "217.052,116.438 214.277,116.438 212.315,118.4 212.315,121.174  214.277,123.137 217.052,123.137 219.015,121.174 219.015,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "267.08,116.438 264.305,116.438 262.342,118.4 262.342,121.174  264.305,123.137 267.08,123.137 269.043,121.174 269.043,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "339.347,116.436 337.384,118.399 337.384,121.174 339.347,123.137  342.121,123.137 344.083,121.174 344.083,118.399 342.121,116.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "179.532,128.944 176.756,128.944 174.794,130.906 174.794,133.682  176.756,135.644 179.532,135.644 181.494,133.682 181.494,130.906  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "267.08,128.944 264.305,128.944 262.342,130.906 262.342,133.682  264.305,135.644 267.08,135.644 269.043,133.682 269.043,130.906  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.97,141.451 64.194,141.451 62.232,143.413 62.232,146.188  64.194,148.151 66.97,148.151 68.932,146.188 68.932,143.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "329.615,141.451 326.839,141.451 324.878,143.413 324.878,146.188  326.839,148.151 329.615,148.151 331.577,146.188 331.577,143.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "339.347,141.451 337.384,143.413 337.384,146.188 339.347,148.151  342.121,148.151 344.083,146.188 344.083,143.413 342.121,141.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "140.161,-6.399 139.507,-5.744 139.507,-4.819 140.161,-4.165  141.086,-4.165 141.74,-4.819 141.74,-5.744 141.086,-6.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "177.681,-6.399 177.027,-5.744 177.027,-4.819 177.681,-4.165  178.607,-4.165 179.261,-4.819 179.261,-5.744 178.607,-6.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "302.75,-6.399 302.097,-5.744 302.097,-4.819 302.75,-4.165  303.676,-4.165 304.329,-4.819 304.329,-5.744 303.676,-6.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "340.272,-6.399 339.617,-5.744 339.617,-4.819 340.272,-4.165  341.197,-4.165 341.851,-4.819 341.851,-5.744 341.197,-6.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "78.552,6.108 77.626,6.108 76.972,6.762 76.972,7.688  77.626,8.341 78.552,8.341 79.205,7.688 79.205,6.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,6.108 177.681,6.108 177.027,6.762 177.027,7.688  177.681,8.341 178.607,8.341 179.261,7.688 179.261,6.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "216.127,6.108 215.201,6.108 214.549,6.762 214.549,7.688  215.201,8.341 216.127,8.341 216.782,7.688 216.782,6.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "241.141,6.108 240.217,6.108 239.562,6.762 239.562,7.688  240.217,8.341 241.141,8.341 241.795,7.688 241.795,6.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "266.155,6.108 265.23,6.108 264.575,6.762 264.575,7.688  265.23,8.341 266.155,8.341 266.809,7.688 266.809,6.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.677,6.108 302.75,6.108 302.097,6.762 302.097,7.688  302.75,8.341 303.677,8.341 304.33,7.688 304.33,6.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.045,18.615 65.119,18.615 64.465,19.269 64.465,20.194  65.119,20.849 66.045,20.849 66.698,20.194 66.698,19.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.058,18.615 90.133,18.615 89.479,19.269 89.479,20.194  90.133,20.849 91.058,20.849 91.713,20.194 91.713,19.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.086,18.615 140.161,18.615 139.507,19.269 139.507,20.194  140.161,20.849 141.086,20.849 141.74,20.194 141.74,19.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,18.615 177.681,18.615 177.027,19.269 177.027,20.194  177.681,20.849 178.607,20.849 179.261,20.194 179.261,19.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.635,18.615 227.709,18.615 227.056,19.269 227.056,20.194  227.709,20.849 228.635,20.849 229.288,20.194 229.288,19.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.168,18.615 290.242,18.615 289.59,19.269 289.59,20.194  290.242,20.849 291.168,20.849 291.823,20.194 291.823,19.269  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.045,31.122 65.119,31.122 64.465,31.776 64.465,32.701  65.119,33.355 66.045,33.355 66.698,32.701 66.698,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.058,31.122 90.133,31.122 89.479,31.776 89.479,32.701  90.133,33.355 91.058,33.355 91.713,32.701 91.713,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.566,31.122 102.64,31.122 101.986,31.776 101.986,32.701  102.64,33.355 103.566,33.355 104.219,32.701 104.219,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "153.593,31.122 152.668,31.122 152.013,31.776 152.013,32.701  152.668,33.355 153.593,33.355 154.246,32.701 154.246,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "166.099,31.122 165.174,31.122 164.52,31.776 164.52,32.701  165.174,33.355 166.099,33.355 166.753,32.701 166.753,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "191.114,31.122 190.188,31.122 189.534,31.776 189.534,32.701  190.188,33.355 191.114,33.355 191.768,32.701 191.768,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "216.127,31.122 215.201,31.122 214.549,31.776 214.549,32.701  215.201,33.355 216.127,33.355 216.782,32.701 216.782,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.635,31.122 227.709,31.122 227.056,31.776 227.056,32.701  227.709,33.355 228.635,33.355 229.288,32.701 229.288,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "253.648,31.122 252.723,31.122 252.069,31.776 252.069,32.701  252.723,33.355 253.648,33.355 254.301,32.701 254.301,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.662,31.122 277.736,31.122 277.081,31.776 277.081,32.701  277.736,33.355 278.662,33.355 279.317,32.701 279.317,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "328.69,31.122 327.765,31.122 327.111,31.776 327.111,32.701  327.765,33.355 328.69,33.355 329.343,32.701 329.343,31.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.566,43.628 102.64,43.628 101.986,44.283 101.986,45.208  102.64,45.862 103.566,45.862 104.219,45.208 104.219,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.072,43.628 115.147,43.628 114.493,44.283 114.493,45.208  115.147,45.862 116.072,45.862 116.726,45.208 116.726,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.086,43.628 140.161,43.628 139.507,44.283 139.507,45.208  140.161,45.862 141.086,45.862 141.74,45.208 141.74,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "166.099,43.628 165.174,43.628 164.52,44.283 164.52,45.208  165.174,45.862 166.099,45.862 166.753,45.208 166.753,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "191.114,43.628 190.188,43.628 189.534,44.283 189.534,45.208  190.188,45.862 191.114,45.862 191.768,45.208 191.768,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.621,43.628 202.696,43.628 202.04,44.283 202.04,45.208  202.696,45.862 203.621,45.862 204.276,45.208 204.276,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.635,43.628 227.709,43.628 227.056,44.283 227.056,45.208  227.709,45.862 228.635,45.862 229.288,45.208 229.288,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.662,43.628 277.736,43.628 277.081,44.283 277.081,45.208  277.736,45.862 278.662,45.862 279.317,45.208 279.317,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.677,43.628 302.75,43.628 302.097,44.283 302.097,45.208  302.75,45.862 303.677,45.862 304.33,45.208 304.33,44.283  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.537,56.136 52.612,56.136 51.958,56.79 51.958,57.715  52.612,58.37 53.537,58.37 54.192,57.715 54.192,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.058,56.136 90.133,56.136 89.479,56.79 89.479,57.715  90.133,58.37 91.058,58.37 91.713,57.715 91.713,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.566,56.136 102.64,56.136 101.986,56.79 101.986,57.715  102.64,58.37 103.566,58.37 104.219,57.715 104.219,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.086,56.136 140.161,56.136 139.507,56.79 139.507,57.715  140.161,58.37 141.086,58.37 141.74,57.715 141.74,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "153.593,56.136 152.668,56.136 152.013,56.79 152.013,57.715  152.668,58.37 153.593,58.37 154.246,57.715 154.246,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.621,56.136 202.696,56.136 202.04,56.79 202.04,57.715  202.696,58.37 203.621,58.37 204.276,57.715 204.276,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "216.127,56.136 215.201,56.136 214.549,56.79 214.549,57.715  215.201,58.37 216.127,58.37 216.782,57.715 216.782,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "253.648,56.136 252.723,56.136 252.069,56.79 252.069,57.715  252.723,58.37 253.648,58.37 254.301,57.715 254.301,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.662,56.136 277.736,56.136 277.081,56.79 277.081,57.715  277.736,58.37 278.662,58.37 279.317,57.715 279.317,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.168,56.136 290.242,56.136 289.59,56.79 289.59,57.715  290.242,58.37 291.168,58.37 291.823,57.715 291.823,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "316.184,56.136 315.258,56.136 314.604,56.79 314.604,57.715  315.258,58.37 316.184,58.37 316.837,57.715 316.837,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "328.69,56.136 327.765,56.136 327.111,56.79 327.111,57.715  327.765,58.37 328.69,58.37 329.343,57.715 329.343,56.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.537,68.643 52.612,68.643 51.958,69.297 51.958,70.222  52.612,70.876 53.537,70.876 54.192,70.222 54.192,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.045,68.643 65.119,68.643 64.465,69.297 64.465,70.222  65.119,70.876 66.045,70.876 66.698,70.222 66.698,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.058,68.643 90.133,68.643 89.479,69.297 89.479,70.222  90.133,70.876 91.058,70.876 91.713,70.222 91.713,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.072,68.643 115.147,68.643 114.493,69.297 114.493,70.222  115.147,70.876 116.072,70.876 116.726,70.222 116.726,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "166.099,68.643 165.174,68.643 164.52,69.297 164.52,70.222  165.174,70.876 166.099,70.876 166.753,70.222 166.753,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,68.643 177.681,68.643 177.027,69.297 177.027,70.222  177.681,70.876 178.607,70.876 179.261,70.222 179.261,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "191.114,68.643 190.188,68.643 189.534,69.297 189.534,70.222  190.188,70.876 191.114,70.876 191.768,70.222 191.768,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "253.648,68.643 252.723,68.643 252.069,69.297 252.069,70.222  252.723,70.876 253.648,70.876 254.301,70.222 254.301,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "266.155,68.643 265.23,68.643 264.575,69.297 264.575,70.222  265.23,70.876 266.155,70.876 266.809,70.222 266.809,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.677,68.643 302.75,68.643 302.097,69.297 302.097,70.222  302.75,70.876 303.677,70.876 304.33,70.222 304.33,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "328.69,68.643 327.765,68.643 327.111,69.297 327.111,70.222  327.765,70.876 328.69,70.876 329.343,70.222 329.343,69.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "78.552,81.149 77.626,81.149 76.972,81.804 76.972,82.729  77.626,83.382 78.552,83.382 79.205,82.729 79.205,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "128.579,81.149 127.654,81.149 127,81.804 127,82.729  127.654,83.382 128.579,83.382 129.234,82.729 129.234,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,81.149 177.681,81.149 177.027,81.804 177.027,82.729  177.681,83.382 178.607,83.382 179.261,82.729 179.261,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.621,81.149 202.696,81.149 202.04,81.804 202.04,82.729  202.696,83.382 203.621,83.382 204.276,82.729 204.276,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "241.141,81.149 240.217,81.149 239.562,81.804 239.562,82.729  240.217,83.382 241.141,83.382 241.795,82.729 241.795,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "328.69,81.149 327.765,81.149 327.111,81.804 327.111,82.729  327.765,83.382 328.69,83.382 329.343,82.729 329.343,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.197,81.149 340.272,81.149 339.617,81.804 339.617,82.729  340.272,83.382 341.197,83.382 341.851,82.729 341.851,81.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.537,93.656 52.612,93.656 51.958,94.31 51.958,95.236  52.612,95.891 53.537,95.891 54.192,95.236 54.192,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.045,93.656 65.119,93.656 64.465,94.31 64.465,95.236  65.119,95.891 66.045,95.891 66.698,95.236 66.698,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "78.552,93.656 77.626,93.656 76.972,94.31 76.972,95.236  77.626,95.891 78.552,95.891 79.205,95.236 79.205,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.566,93.656 102.64,93.656 101.986,94.31 101.986,95.236  102.64,95.891 103.566,95.891 104.219,95.236 104.219,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.072,93.656 115.147,93.656 114.493,94.31 114.493,95.236  115.147,95.891 116.072,95.891 116.726,95.236 116.726,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "128.579,93.656 127.654,93.656 127,94.31 127,95.236  127.654,95.891 128.579,95.891 129.234,95.236 129.234,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "153.593,93.656 152.668,93.656 152.013,94.31 152.013,95.236  152.668,95.891 153.593,95.891 154.246,95.236 154.246,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,93.656 177.681,93.656 177.027,94.31 177.027,95.236  177.681,95.891 178.607,95.891 179.261,95.236 179.261,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "216.127,93.656 215.201,93.656 214.549,94.31 214.549,95.236  215.201,95.891 216.127,95.891 216.782,95.236 216.782,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "266.155,93.656 265.23,93.656 264.575,94.31 264.575,95.236  265.23,95.891 266.155,95.891 266.809,95.236 266.809,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "316.184,93.656 315.258,93.656 314.604,94.31 314.604,95.236  315.258,95.891 316.184,95.891 316.837,95.236 316.837,94.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.537,106.164 52.612,106.164 51.958,106.818 51.958,107.743  52.612,108.397 53.537,108.397 54.192,107.743 54.192,106.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "78.552,106.164 77.626,106.164 76.972,106.818 76.972,107.743  77.626,108.397 78.552,108.397 79.205,107.743 79.205,106.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.072,106.164 115.147,106.164 114.493,106.818 114.493,107.743  115.147,108.397 116.072,108.397 116.726,107.743 116.726,106.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "128.579,106.164 127.654,106.164 127,106.818 127,107.743  127.654,108.397 128.579,108.397 129.234,107.743 129.234,106.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.662,106.164 277.736,106.164 277.081,106.818 277.081,107.743  277.736,108.397 278.662,108.397 279.317,107.743 279.317,106.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.197,106.164 340.272,106.164 339.617,106.818 339.617,107.743  340.272,108.397 341.197,108.397 341.851,107.743 341.851,106.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.058,118.67 90.133,118.67 89.479,119.325 89.479,120.25  90.133,120.903 91.058,120.903 91.713,120.25 91.713,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.566,118.67 102.64,118.67 101.986,119.325 101.986,120.25  102.64,120.903 103.566,120.903 104.219,120.25 104.219,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "153.593,118.67 152.668,118.67 152.013,119.325 152.013,120.25  152.668,120.903 153.593,120.903 154.246,120.25 154.246,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,118.67 177.681,118.67 177.027,119.325 177.027,120.25  177.681,120.903 178.607,120.903 179.261,120.25 179.261,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.621,118.67 202.696,118.67 202.04,119.325 202.04,120.25  202.696,120.903 203.621,120.903 204.276,120.25 204.276,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.635,118.67 227.709,118.67 227.056,119.325 227.056,120.25  227.709,120.903 228.635,120.903 229.288,120.25 229.288,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "241.141,118.67 240.217,118.67 239.562,119.325 239.562,120.25  240.217,120.903 241.141,120.903 241.795,120.25 241.795,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "253.648,118.67 252.723,118.67 252.069,119.325 252.069,120.25  252.723,120.903 253.648,120.903 254.301,120.25 254.301,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.168,118.67 290.242,118.67 289.59,119.325 289.59,120.25  290.242,120.903 291.168,120.903 291.823,120.25 291.823,119.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.537,131.177 52.612,131.177 51.958,131.831 51.958,132.756  52.612,133.41 53.537,133.41 54.192,132.756 54.192,131.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.058,131.177 90.133,131.177 89.479,131.831 89.479,132.756  90.133,133.41 91.058,133.41 91.713,132.756 91.713,131.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "128.579,131.177 127.654,131.177 127,131.831 127,132.756  127.654,133.41 128.579,133.41 129.234,132.756 129.234,131.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.086,131.177 140.161,131.177 139.507,131.831 139.507,132.756  140.161,133.41 141.086,133.41 141.74,132.756 141.74,131.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.621,131.177 202.696,131.177 202.04,131.831 202.04,132.756  202.696,133.41 203.621,133.41 204.276,132.756 204.276,131.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.635,131.177 227.709,131.177 227.056,131.831 227.056,132.756  227.709,133.41 228.635,133.41 229.288,132.756 229.288,131.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.537,143.684 52.612,143.684 51.958,144.338 51.958,145.264  52.612,145.918 53.537,145.918 54.192,145.264 54.192,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "78.552,143.684 77.626,143.684 76.972,144.338 76.972,145.264  77.626,145.918 78.552,145.918 79.205,145.264 79.205,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.072,143.684 115.147,143.684 114.493,144.338 114.493,145.264  115.147,145.918 116.072,145.918 116.726,145.264 116.726,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.086,143.684 140.161,143.684 139.507,144.338 139.507,145.264  140.161,145.918 141.086,145.918 141.74,145.264 141.74,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.607,143.684 177.681,143.684 177.027,144.338 177.027,145.264  177.681,145.918 178.607,145.918 179.261,145.264 179.261,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "266.155,143.684 265.23,143.684 264.575,144.338 264.575,145.264  265.23,145.918 266.155,145.918 266.809,145.264 266.809,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "316.184,143.684 315.258,143.684 314.604,144.338 314.604,145.264  315.258,145.918 316.184,145.918 316.837,145.264 316.837,144.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "77.534,-6.623 76.749,-5.837 76.749,-4.727 77.534,-3.942  78.643,-3.942 79.428,-4.727 79.428,-5.837 78.643,-6.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "102.548,-6.623 101.762,-5.837 101.762,-4.727 102.548,-3.942  103.657,-3.942 104.443,-4.727 104.443,-5.837 103.657,-6.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "152.576,-6.623 151.79,-5.837 151.79,-4.727 152.576,-3.942  153.684,-3.942 154.47,-4.727 154.47,-5.837 153.684,-6.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "215.109,-6.623 214.325,-5.837 214.325,-4.727 215.109,-3.942  216.219,-3.942 217.005,-4.727 217.005,-5.837 216.219,-6.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "240.123,-6.623 239.339,-5.837 239.339,-4.727 240.123,-3.942  241.234,-3.942 242.019,-4.727 242.019,-5.837 241.234,-6.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "290.151,-6.623 289.366,-5.837 289.366,-4.727 290.151,-3.942  291.261,-3.942 292.045,-4.727 292.045,-5.837 291.261,-6.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.657,5.885 102.548,5.885 101.762,6.67 101.762,7.78  102.548,8.564 103.657,8.564 104.443,7.78 104.443,6.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "216.219,18.392 215.109,18.392 214.325,19.176 214.325,20.287  215.109,21.072 216.219,21.072 217.005,20.287 217.005,19.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.755,18.392 277.644,18.392 276.859,19.176 276.859,20.287  277.644,21.072 278.755,21.072 279.538,20.287 279.538,19.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.768,18.392 302.658,18.392 301.872,19.176 301.872,20.287  302.658,21.072 303.768,21.072 304.553,20.287 304.553,19.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.289,18.392 340.179,18.392 339.394,19.176 339.394,20.287  340.179,21.072 341.289,21.072 342.074,20.287 342.074,19.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "128.672,30.898 127.561,30.898 126.777,31.684 126.777,32.794  127.561,33.579 128.672,33.579 129.457,32.794 129.457,31.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "241.235,30.898 240.123,30.898 239.339,31.684 239.339,32.794  240.123,33.579 241.235,33.579 242.019,32.794 242.019,31.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.768,30.898 302.658,30.898 301.872,31.684 301.872,32.794  302.658,33.579 303.768,33.579 304.553,32.794 304.553,31.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "178.699,43.406 177.589,43.406 176.804,44.191 176.804,45.3  177.589,46.085 178.699,46.085 179.484,45.3 179.484,44.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "216.219,43.406 215.109,43.406 214.325,44.191 214.325,45.3  215.109,46.085 216.219,46.085 217.005,45.3 217.005,44.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.261,43.406 290.151,43.406 289.366,44.191 289.366,45.3  290.151,46.085 291.261,46.085 292.045,45.3 292.045,44.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "316.276,43.406 315.164,43.406 314.381,44.191 314.381,45.3  315.164,46.085 316.276,46.085 317.061,45.3 317.061,44.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.289,43.406 340.179,43.406 339.394,44.191 339.394,45.3  340.179,46.085 341.289,46.085 342.074,45.3 342.074,44.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.137,55.913 65.027,55.913 64.241,56.697 64.241,57.807  65.027,58.593 66.137,58.593 66.922,57.807 66.922,56.697  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.165,55.913 115.054,55.913 114.27,56.697 114.27,57.807  115.054,58.593 116.165,58.593 116.949,57.807 116.949,56.697  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.657,68.419 102.548,68.419 101.762,69.204 101.762,70.314  102.548,71.1 103.657,71.1 104.443,70.314 104.443,69.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "153.685,68.419 152.576,68.419 151.79,69.204 151.79,70.314  152.576,71.1 153.685,71.1 154.47,70.314 154.47,69.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.713,68.419 202.602,68.419 201.818,69.204 201.818,70.314  202.602,71.1 203.713,71.1 204.497,70.314 204.497,69.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "241.235,68.419 240.123,68.419 239.339,69.204 239.339,70.314  240.123,71.1 241.235,71.1 242.019,70.314 242.019,69.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.289,68.419 340.179,68.419 339.394,69.204 339.394,70.314  340.179,71.1 341.289,71.1 342.074,70.314 342.074,69.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "53.63,80.926 52.52,80.926 51.735,81.71 51.735,82.821  52.52,83.606 53.63,83.606 54.415,82.821 54.415,81.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "153.685,80.926 152.576,80.926 151.79,81.71 151.79,82.821  152.576,83.606 153.685,83.606 154.47,82.821 154.47,81.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.726,80.926 227.615,80.926 226.831,81.71 226.831,82.821  227.615,83.606 228.726,83.606 229.513,82.821 229.513,81.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.755,80.926 277.644,80.926 276.859,81.71 276.859,82.821  277.644,83.606 278.755,83.606 279.538,82.821 279.538,81.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.768,80.926 302.658,80.926 301.872,81.71 301.872,82.821  302.658,83.606 303.768,83.606 304.553,82.821 304.553,81.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "328.781,93.434 327.671,93.434 326.888,94.218 326.888,95.328  327.671,96.112 328.781,96.112 329.568,95.328 329.568,94.218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.151,105.94 90.04,105.94 89.256,106.725 89.256,107.835  90.04,108.621 91.151,108.621 91.935,107.835 91.935,106.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "166.193,105.94 165.082,105.94 164.297,106.725 164.297,107.835  165.082,108.621 166.193,108.621 166.976,107.835 166.976,106.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "241.235,105.94 240.123,105.94 239.339,106.725 239.339,107.835  240.123,108.621 241.235,108.621 242.019,107.835 242.019,106.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "278.755,118.447 277.644,118.447 276.859,119.231 276.859,120.342  277.644,121.127 278.755,121.127 279.538,120.342 279.538,119.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "303.768,118.447 302.658,118.447 301.872,119.231 301.872,120.342  302.658,121.127 303.768,121.127 304.553,120.342 304.553,119.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "78.644,130.954 77.534,130.954 76.749,131.738 76.749,132.849  77.534,133.633 78.644,133.633 79.428,132.849 79.428,131.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "103.657,130.954 102.548,130.954 101.762,131.738 101.762,132.849  102.548,133.633 103.657,133.633 104.443,132.849 104.443,131.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "166.193,130.954 165.082,130.954 164.297,131.738 164.297,132.849  165.082,133.633 166.193,133.633 166.976,132.849 166.976,131.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.289,130.954 340.179,130.954 339.394,131.738 339.394,132.849  340.179,133.633 341.289,133.633 342.074,132.849 342.074,131.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "203.713,143.461 202.602,143.461 201.818,144.246 201.818,145.355  202.602,146.141 203.713,146.141 204.497,145.355 204.497,144.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "228.726,143.461 227.615,143.461 226.831,144.246 226.831,145.355  227.615,146.141 228.726,146.141 229.513,145.355 229.513,144.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.261,143.461 290.151,143.461 289.366,144.246 289.366,145.355  290.151,146.141 291.261,146.141 292.045,145.355 292.045,144.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "64.656,-7.516 63.348,-6.207 63.348,-4.356 64.656,-3.048  66.507,-3.048 67.816,-4.356 67.816,-6.207 66.507,-7.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "114.684,-7.516 113.376,-6.207 113.376,-4.356 114.684,-3.048  116.535,-3.048 117.843,-4.356 117.843,-6.207 116.535,-7.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "189.726,-7.516 188.418,-6.207 188.418,-4.356 189.726,-3.048  191.576,-3.048 192.884,-4.356 192.884,-6.207 191.576,-7.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "264.767,-7.516 263.458,-6.207 263.458,-4.356 264.767,-3.048  266.618,-3.048 267.926,-4.356 267.926,-6.207 266.618,-7.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "277.276,-7.516 275.966,-6.207 275.966,-4.356 277.276,-3.048  279.124,-3.048 280.433,-4.356 280.433,-6.207 279.124,-7.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "279.124,4.991 277.276,4.991 275.966,6.3 275.966,8.15  277.276,9.458 279.124,9.458 280.433,8.15 280.433,6.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.66,4.991 339.808,4.991 338.499,6.3 338.499,8.15  339.808,9.458 341.66,9.458 342.968,8.15 342.968,6.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "154.056,17.499 152.204,17.499 150.897,18.806 150.897,20.656  152.204,21.965 154.056,21.965 155.365,20.656 155.365,18.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "204.082,17.499 202.234,17.499 200.924,18.806 200.924,20.656  202.234,21.965 204.082,21.965 205.391,20.656 205.391,18.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "329.189,17.535 327.339,17.535 326.031,18.843 326.031,20.693  327.339,22.002 329.189,22.002 330.496,20.693 330.496,18.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.55,30.005 139.697,30.005 138.39,31.313 138.39,33.163  139.697,34.471 141.55,34.471 142.856,33.163 142.856,31.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "179.069,30.005 177.22,30.005 175.911,31.313 175.911,33.163  177.22,34.471 179.069,34.471 180.377,33.163 180.377,31.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "266.618,30.005 264.767,30.005 263.458,31.313 263.458,33.163  264.767,34.471 266.618,34.471 267.926,33.163 267.926,31.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "316.682,30.042 314.831,30.042 313.524,31.35 313.524,33.201  314.831,34.509 316.682,34.509 317.99,33.201 317.99,31.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.507,42.512 64.656,42.512 63.349,43.82 63.349,45.671  64.656,46.979 66.507,46.979 67.816,45.671 67.816,43.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.041,42.512 127.191,42.512 125.883,43.82 125.883,45.671  127.191,46.979 129.041,46.979 130.35,45.671 130.35,43.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "79.051,55.056 77.2,55.056 75.892,56.364 75.892,58.214  77.2,59.522 79.051,59.522 80.36,58.214 80.36,56.364  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "229.097,55.019 227.246,55.019 225.938,56.328 225.938,58.177  227.246,59.486 229.097,59.486 230.405,58.177 230.405,56.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "304.176,55.056 302.324,55.056 301.017,56.364 301.017,58.214  302.324,59.522 304.176,59.522 305.484,58.214 305.484,56.364  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "341.66,55.019 339.808,55.019 338.499,56.328 338.499,58.177  339.808,59.486 341.66,59.486 342.968,58.177 342.968,56.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.041,67.526 127.191,67.526 125.883,68.835 125.883,70.684  127.191,71.992 129.041,71.992 130.35,70.684 130.35,68.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.631,67.526 289.781,67.526 288.474,68.835 288.474,70.684  289.781,71.992 291.631,71.992 292.94,70.684 292.94,68.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.558,80.069 89.707,80.069 88.399,81.378 88.399,83.229  89.707,84.537 91.558,84.537 92.866,83.229 92.866,81.378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "166.599,80.069 164.748,80.069 163.44,81.378 163.44,83.229  164.748,84.537 166.599,84.537 167.907,83.229 167.907,81.378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "266.618,80.033 264.767,80.033 263.458,81.341 263.458,83.191  264.767,84.5 266.618,84.5 267.926,83.191 267.926,81.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "291.631,80.033 289.781,80.033 288.474,81.341 288.474,83.191  289.781,84.5 291.631,84.5 292.94,83.191 292.94,81.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.507,105.046 64.656,105.046 63.349,106.356 63.349,108.205  64.656,109.513 66.507,109.513 67.816,108.205 67.816,106.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "104.028,105.046 102.177,105.046 100.869,106.356 100.869,108.205  102.177,109.513 104.028,109.513 105.336,108.205 105.336,106.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "141.55,105.046 139.697,105.046 138.39,106.356 138.39,108.205  139.697,109.513 141.55,109.513 142.856,108.205 142.856,106.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "204.119,105.084 202.269,105.084 200.962,106.392 200.962,108.242  202.269,109.55 204.119,109.55 205.429,108.242 205.429,106.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "229.097,105.046 227.246,105.046 225.938,106.356 225.938,108.205  227.246,109.513 229.097,109.513 230.405,108.205 230.405,106.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "316.645,105.046 314.795,105.046 313.487,106.356 313.487,108.205  314.795,109.513 316.645,109.513 317.953,108.205 317.953,106.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "329.152,105.046 327.301,105.046 325.993,106.356 325.993,108.205  327.301,109.513 329.152,109.513 330.461,108.205 330.461,106.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "54,117.554 52.15,117.554 50.842,118.862 50.842,120.712  52.15,122.021 54,122.021 55.308,120.712 55.308,118.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "66.507,117.554 64.656,117.554 63.349,118.862 63.349,120.712  64.656,122.021 66.507,122.021 67.816,120.712 67.816,118.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.041,117.554 127.191,117.554 125.883,118.862 125.883,120.712  127.191,122.021 129.041,122.021 130.35,120.712 130.35,118.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "116.535,130.061 114.684,130.061 113.376,131.369 113.376,133.218  114.684,134.527 116.535,134.527 117.843,133.218 117.843,131.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "254.111,130.061 252.259,130.061 250.952,131.369 250.952,133.218  252.259,134.527 254.111,134.527 255.42,133.218 255.42,131.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "279.16,130.097 277.31,130.097 276.002,131.405 276.002,133.254  277.31,134.564 279.16,134.564 280.47,133.254 280.47,131.405  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "91.521,142.567 89.67,142.567 88.362,143.875 88.362,145.726  89.67,147.034 91.521,147.034 92.829,145.726 92.829,143.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_16_)",
    fill: "#BFBFBF",
    points: "129.041,142.567 127.191,142.567 125.883,143.875 125.883,145.726  127.191,147.034 129.041,147.034 130.35,145.726 130.35,143.875  "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetireOnline);
export default __webpack_public_path__ + "static/media/retire-online.c5fa2589ba4f60872c91b96f634e7fd6.svg";
export { ForwardRef as ReactComponent };